import { useEffect } from 'react';
import { shouldLoadSupportChat } from '../services/impersonationSession';

const useSupportChat = () => {
    useEffect(() => {
        // the chat widget would report the impersonated user to Tawk.to; it never loads in an impersonation tab.
        // It checks the page shown now, not the tab: after /unsubscribe the next page gets the chat back
        if (!shouldLoadSupportChat()) {
            return;
        }

        const loadChat = () => {
            window.Tawk_API = window.Tawk_API || {};
            window.Tawk_LoadStart = new Date();

            const s1 = document.createElement('script');
            s1.async = true;
            s1.src = 'https://embed.tawk.to/67c4c969113131190a28f4f0/1ilcb5hne';
            s1.setAttribute('crossorigin', '*');

            const s0 = document.getElementsByTagName('script')[0];
            s0.parentNode?.insertBefore(s1, s0);

            return () => {
                const chatMessangerScript = document.querySelector(
                    'script[src="https://embed.tawk.to/67c4c969113131190a28f4f0/1ilcb5hne"]'
                );
                if (chatMessangerScript) chatMessangerScript.remove();
                delete window.Tawk_API;
            };
        };

        return loadChat();
    }, []);
};

export default useSupportChat;
